/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ApplicationFormStatus = {
    Draft: 'DRAFT',
    Submitted: 'SUBMITTED',
    PartiallySigned: 'PARTIALLY_SIGNED',
    Signed: 'SIGNED',
    Archived: 'ARCHIVED'
} as const;
export type ApplicationFormStatus = typeof ApplicationFormStatus[keyof typeof ApplicationFormStatus];


export function instanceOfApplicationFormStatus(value: any): boolean {
    for (const key in ApplicationFormStatus) {
        if (Object.prototype.hasOwnProperty.call(ApplicationFormStatus, key)) {
            if (ApplicationFormStatus[key as keyof typeof ApplicationFormStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ApplicationFormStatusFromJSON(json: any): ApplicationFormStatus {
    return ApplicationFormStatusFromJSONTyped(json, false);
}

export function ApplicationFormStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationFormStatus {
    return json as ApplicationFormStatus;
}

export function ApplicationFormStatusToJSON(value?: ApplicationFormStatus | null): any {
    return value as any;
}

export function ApplicationFormStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): ApplicationFormStatus {
    return value as ApplicationFormStatus;
}

